(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* — Mantener scroll al ancla del producto — */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  /* — Cargar más productos SOLO CON BOTÓN (versión simple) — */
  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('[data-load-more-wrapper]');
    if (!wrapper) return;

    const btn = wrapper.querySelector('[data-load-more-btn]');
    const stateEl = wrapper.querySelector('#LoadMoreState');
    const list = document.getElementById('ResultsList');
    if (!btn || !stateEl || !list) return;

    let nextUrl = stateEl.dataset.nextUrl || '';
    let loading = false;

    const setLoading = (is) => {
      loading = is;
      btn.disabled = is;
      btn.setAttribute('aria-busy', String(is));
      // Cambiar texto mientras carga
      if (is) {
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Cargando...';
      } else {
        btn.textContent = btn.dataset.originalText || 'Más productos';
      }
    };

    const getNextUrlFromDoc = (doc) => {
      const nextState = doc.querySelector('#LoadMoreState');
      return nextState ? nextState.dataset.nextUrl || '' : '';
    };

    // SOLUCIÓN CLAVE: Desactivar el IntersectionObserver del PaginatedList
    setTimeout(() => {
      // Encontrar el elemento results-list y desactivar su observer
      const resultsList = document.querySelector('results-list');
      if (resultsList && resultsList.infinityScrollObserver) {
        console.log('Desactivando IntersectionObserver automático');
        resultsList.infinityScrollObserver.disconnect();
        resultsList.infinityScrollObserver = undefined;
      }
    }, 500);

    btn.addEventListener('click', async () => {
      if (!nextUrl || loading) return;
      
      setLoading(true);
      try {
        const resp = await fetch(nextUrl, { credentials: 'same-origin' });
        const text = await resp.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        const newList = doc.getElementById('ResultsList');
        if (newList) {
          const items = [...newList.children];
          items.forEach((li) => list.appendChild(li));
        }

        // Actualizar la URL para la siguiente carga
        nextUrl = getNextUrlFromDoc(doc);

        if (!nextUrl) {
          // Ocultar botón cuando no hay más productos
          btn.hidden = true;
          btn.setAttribute('aria-hidden', 'true');
        }
      } catch (e) {
        console.error('Load more failed:', e);
        btn.textContent = 'Error, intenta de nuevo';
        setTimeout(() => {
          btn.textContent = btn.dataset.originalText || 'Más productos';
        }, 2000);
      } finally {
        setLoading(false);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
